import { Component, OnInit, ViewChild, Input, AfterContentInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../create-account/create-account.component';
import { Router, ActivatedRoute } from '@angular/router';
import { PlayerService } from '../../services/player.service';
import { ScrollToService } from '../../services/scroll-to.service';

@Component({
  selector: 's18-try-it-free',
  templateUrl: './try-it-free.component.html',
  styleUrls: ['./try-it-free.component.scss']
})
export class TryItFreeComponent implements OnInit, AfterContentInit {
  @Input() showHeader: boolean = true;
  @ViewChild('videoPlayer', { static: true }) videoplayer: any;

  private fragment: string;
  autoplay: boolean = true;
  userCount: number = 0;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private playerService: PlayerService,
    private route: ActivatedRoute,
    private scrollTo: ScrollToService,
  ) { }

  ngOnInit() {
    this.playerService.getUserCount('S18')
      .subscribe(resp => { this.userCount = JSON.parse(resp.d).count });
    this.route.fragment.subscribe(fragment => {
      if (!fragment && this.autoplay) {
        this.videoplayer.nativeElement.play().catch(ex => {
          this.autoplay = false;
        });
      } else {
        this.fragment = fragment;
        this.autoplay = false;
      }
    });
  }

  playVideo() {
    this.autoplay = true;
    this.videoplayer.nativeElement.play();
  }

  ngAfterContentInit() {
    this.scrollTo.scrollTo({ target: '#' + this.fragment });
  }

  showRegistrationDialog() {
    let dialogRef = this.dialog.open(CreateAccountComponent, {
      width: '500px',
      data: {
        source: 'tryitfree'
      }
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.router.navigateByUrl("/dashboard/tryitfree");;
      }
    });
  }

}
